import Loadable from 'UIComponents/decorators/Loadable';
import LoadingComponent from '../components/utility/LoadingComponent';
export const makeAsyncComponent = loader => Loadable({
  delay: 500,
  loader,
  LoadingComponent
});